export default __webpack_public_path__ + "static/media/2829.ae94ef39.png";